import { RAISE_BASE_URL, RAISE_QUERY_URL } from "constants/endpoints";
import { get } from "services/api";

const BRAND_DETAILS_URL_TO_FETCH = `${RAISE_QUERY_URL}?type=paths&keywords=`;

export const getBrandDetails = async (brandName) => {
  const resp = await get(BRAND_DETAILS_URL_TO_FETCH + brandName);

  return resp.data;
};

export const getBrandDiscounts = async ({
  currentPath,
  page,
  perPage,
  sorting,
  priceRange,
  groupedListing
}) => {
  const baseUrl = `${RAISE_BASE_URL}/${currentPath}.json`;
  const url = `${baseUrl}?${sorting.sort}_sort=${
    sorting.order
  }&per=${perPage}&page=${page}&value[]=${priceRange.priceMin}&value[]=${
    priceRange.priceMax
  }&group_listings=${!!groupedListing}`;
  const resp = await get(url);

  return resp.data;
};
